export default __webpack_public_path__ + "static/media/rightArrow.d5b97d27.gif";